import React from 'react';
import Layout from '../components/Layout';
import CommonHelmet from '../components/CommonHelmet';
import BannerInner from '../components/BannerInner';
import Archivebox from '../components/Archivebox';
import galleryimg from '../assets/images/uniworld-new-4.jpg';
import eventimg from '../assets/images/page-bg1.jpg';
import videoimg from '../assets/images/page-bg.jpg';

const Archives = () => {
    const title='Best Real Estate Company Lucknow | Urbanaidinfratech';
    const description='Urbanaidinfratech is one of the leading Real Estate company in Lucknow. Get luxurious homes in ready to move condition at most prime locations at lucrative prices.';
    const canonical='/archives';
    const archiveData = [
        {
            id:1,
            title:'Gallery',
            image:galleryimg,
            to:'',
        },
        {
            id:2,
            title:'Event',
            image:eventimg,
            to:'',
        },
        {
            id:3,
            title:'Video',
            image:videoimg,
            to:'',
        },
    ];

    return (
        <>
            <CommonHelmet title={title} canonical={canonical} description={description} />
            <BannerInner title={'Archives'} />
            <section className='archives flex py-8'>
                <div className='container mx-auto'>
                    <div className='flex flex-col md:flex-row flex-wrap justify-start py-7 mb-5 relative'>
                        <Archivebox archiveData={archiveData} />
                    </div>
                </div>
            </section>
        </>
    );
}

export default Archives;
